(function () {
  var STORAGE_KEY = 'theme-color-scheme';
  var root = document.documentElement;

  function currentScheme() {
    return root.getAttribute('data-scheme') === 'dark' ? 'dark' : 'light';
  }

  function apply(scheme) {
    if (scheme === 'dark') {
      root.setAttribute('data-scheme', 'dark');
    } else {
      root.removeAttribute('data-scheme');
    }
    document.querySelectorAll('[data-scheme-toggle-label]').forEach(function (el) {
      el.textContent = scheme === 'dark'
        ? (window.themeStrings && window.themeStrings.lightModeOff || 'Light Mode: Off')
        : (window.themeStrings && window.themeStrings.lightModeOn || 'Light Mode: On');
    });
    document.querySelectorAll('[data-scheme-toggle]').forEach(function (btn) {
      btn.setAttribute('aria-pressed', scheme === 'dark' ? 'true' : 'false');
    });
  }

  var saved = null;
  try {
    saved = localStorage.getItem(STORAGE_KEY);
  } catch (e) {
    /* localStorage unavailable (private mode, etc.) — fall back to light. */
  }
  apply(saved === 'dark' ? 'dark' : 'light');

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-scheme-toggle]');
    if (!btn) return;
    var next = currentScheme() === 'dark' ? 'light' : 'dark';
    apply(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch (e) {
      /* ignore */
    }
  });
})();
